import React, { useContext, useEffect,useState } from 'react'
import Sidebar from '../Components/Sidebar'
import '../css/sb-admin-2.min.css'
import Topbar from '../Components/Topbar';
import { ButtonGroup, Collapse, Button } from 'react-bootstrap';
import { AppColors } from '../css/AppColors';
import { Context } from '../Context/DataContext';
import { apiRequest } from '../utils/apiCalls';
import { Link } from 'react-router-dom';

const Dashboard = () => {


    const { state } = useContext(Context)
    const [data, setData] = useState([]);
    function getDashboard() {
        apiRequest({ st_id: state.storeData.st_id }, 'getdashboard')
            .then(data => {
                if (data.status == '1') {
                    setData(data.data)
                }
            })
    }


    useEffect(() => {
        getDashboard();
    }, [])
    return (
        <div id="page-top">
            <div id="wrapper" >
                <Sidebar />
                <div id="content-wrapper" class="d-flex flex-column">
                    <div id="content">
                        <Topbar />
                        <div className="d-sm-flex align-items-center justify-content-between mb-4" style={{ paddingRight: 20, paddingLeft: 20 }}>
                            <h1 className="h3 mb-0 text-gray-800" style={{ fontFamily: 'RBo' }} >Dashboard</h1>
                            {/* <Button
                                className="rBBtn"
                                style={{ backgroundColor: AppColors.primary, color: 'white', textAlign: 'right' }}
                                variant="outline-none"

                                aria-controls="example-collapse-text"
                            >
                                
                                Generate Report
                            </Button> */}
                            {/*
                            
                            <a
                                href="#"
                                className="d-none d-sm-inline-block btn btn-sm  shadow-sm"
                            >
                                <i className="fas fa-download fa-sm text-white-50" /> Generate Report
                            </a>
                        < */}
                        </div>
                        {/* Content Row */}
                        <div className="row" style={{ paddingRight: 20, paddingLeft: 20 }}  >
                            {/* Earnings (Monthly) Card Example */}
                            <Link to = "/viewCustomers" className="col-xl-3 col-md-6 mb-4" >
                                <div className="card border-left-primary shadow h-100 py-2" style={{ paddingLeft: 5, paddingRight: 5 }}   >
                                    <div className="card-body">
                                        <div className="row no-gutters align-items-center">
                                            <div className="col mr-2">
                                                <div className="text-xs font-weight-bold text-primary text-uppercase mb-1" style={{ fontFamily: 'RBo', fontSize: 15 }}>
                                                    Customers
                                                </div>
                                                <div className="h5 mb-0 font-weight-bold text-gray-800" style={{ fontSize: 15 }}>
                                                    {data?.customers}
                                                </div>
                                            </div>
                                            <div className="col-auto">
                                                <i className="fas fa-calendar fa-2x text-gray-300" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                            {/* Earnings (Monthly) Card Example */}
                            <Link to = "/viewProducts" className="col-xl-3 col-md-6 mb-4">
                                <div className="card border-left-success shadow h-100 py-2" style={{ paddingLeft: 5, paddingRight: 5 }}   >
                                    <div className="card-body">
                                        <div className="row no-gutters align-items-center">
                                            <div className="col mr-2">
                                                <div className="text-xs font-weight-bold text-success text-uppercase mb-1" style={{ fontFamily: 'RBo', fontSize: 15 }}>
                                                    Products
                                                </div>
                                                <div className="h5 mb-0 font-weight-bold text-gray-800" style={{ fontSize: 15 }}>
                                                    {data?.products}
                                                </div>
                                            </div>
                                            <div className="col-auto">
                                                <i className="fas fa-dollar-sign fa-2x text-gray-300" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                            {/* Earnings (Monthly) Card Example */}
                            <Link to = "/viewOrder" className="col-xl-3 col-md-6 mb-4">
                                <div className="card border-left-info shadow h-100 py-2" style={{ paddingLeft: 5, paddingRight: 5 }}   >
                                    <div className="card-body">
                                        <div className="row no-gutters align-items-center">
                                            <div className="col mr-2">
                                                <div className="text-xs font-weight-bold text-info text-uppercase mb-1" style={{ fontFamily: 'RBo', fontSize: 15 }}>
                                                    Orders
                                                </div>
                                                <div className="row no-gutters align-items-center">
                                                    <div className="col-auto">
                                                        <div className="h5 mb-0 mr-3 font-weight-bold text-gray-800" style={{ fontSize: 15, marginLeft: 10 }}>
                                                            {data?.orders}
                                                        </div>
                                                    </div>
                                                    {/* <div className="col" style={{ width: 100 }} >
                                                        <div className="progress progress-sm mr-2" style={{ width: "100%" }} >
                                                            <div
                                                                className="progress-bar bg-info"
                                                                role="progressbar"
                                                                style={{ width: "50%" }}
                                                                aria-valuenow={50}
                                                                aria-valuemin={0}
                                                                aria-valuemax={100}
                                                            />
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                            <div className="col-auto">
                                                <i className="fas fa-comments fa-2x text-gray-300" />
                                            </div>
                                            {/* <div className="col-auto">
                                                <i className="fas fa-clipboard-list fa-2x text-gray-300" />
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </Link>
                            {/* Pending Requests Card Example */}
                            <div className="col-xl-3 col-md-6 mb-4">
                                <div className="card border-left-warning shadow h-100 py-2" style={{ paddingLeft: 5, paddingRight: 5 }}   >
                                    <div className="card-body">
                                        <div className="row no-gutters align-items-center">
                                            <div className="col mr-2">
                                                <div className="text-xs font-weight-bold text-warning text-uppercase mb-1" style={{ fontFamily: 'RBo', fontSize: 15 }}>
                                                    Prescriptions
                                                </div>
                                                <div className="h5 mb-0 font-weight-bold text-gray-800" style={{ fontSize: 15 }}>{data?.prescriptions}</div>
                                            </div>
                                            <div className="col-auto">
                                                <i className="fas fa-comments fa-2x text-gray-300" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Content Row */}
                        <div className="row"></div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Dashboard
